import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './cubicCapacityModal.css';
import CreateEdit from './CreateEdit';

function CubicCapacityCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          closeCreateEditForm={handleClose}
          CubicCapacityditDatas={null}
          editStatus={false}
          productId={productId}
          setNewValue={setNewValue}
        />
      </DialogContent>
    </Dialog>
  );
}

export default CubicCapacityCreateModal;
